<template>
   <div>
      <process-header :step="4"/>
      <div class="body">
         <common-form
            form-title="Vision & Mission"
            :back-route="{name: 'energy-baseline-mhp'}"
            :errors="errors.non_field_errors"
            @submit="save"
            @save-and-continue="saveAndContinue"
            >
            <input-field
               v-model="form.vision"
               :errors="errors.vision"
               type="textarea"
               label="Vision"
               :extra-attributes="{maxlength: 64, rows: 1}"
            />
            <input-field
               v-model="form.mission"
               :errors="errors.mission"
               type="textarea"
               label="Mission"
               :extra-attributes="{maxlength: 64, rows: 1}"
            />
         </common-form>
      </div>
   </div>
</template>

<script>
import ProcessHeader from "../Header";
import CommonForm from '@/components/organisms/Home/Plan/Form';
import InputField from '@/components/molecules/Login/InputField';
import { mapGetters } from 'vuex';
import { fetchWithAuthToken, postWithAuthToken } from '../../../../../axios';
import { showError, showSuccess } from '../../../../../js/ui-helpers';
import { getDefaultErrors, updateProps } from '../../../../../js/form-helpers';
export default {
   name: "vision-mission",
   components: {
      ProcessHeader,
      CommonForm,
      InputField,
   },
   data()
   {
      const form =  {
         vision: "",
         mission: "",
      }; 
      return {
         form,
         errors: getDefaultErrors(form),
      };
   },
   computed: {
      ...mapGetters('plan', ['getPlan']),
      apiUrl()
      {
         return `/api/plan/${this.planId}/mission-vision`;
      },
      planId()
      {
         return this.$route.params.id;
      },
   },
   async created()
   {
      const { data } = await fetchWithAuthToken(this.apiUrl);
      this.form = data;
   },
   methods: {
      resetErrors()
      {
         updateProps(this.errors, getDefaultErrors(this.form));
      },
      save({goToNext=false})
      {
         this.resetErrors();
         postWithAuthToken(this.apiUrl, this.form, {method: 'put'})
         .then( () =>
         {
            showSuccess('Mission & Vision', 'Sucessfully saved mission & vision');
            if (goToNext) 
               this.$router.push({name: 'opp-and-challenges'});
         })
         .catch(({response}) =>
         {
            if (response && response.status===400)
            {
               updateProps(this.errors, response.data);
            }
            showError('Mission & Vision', 'Could save the changes');
         });
      },
      saveAndContinue()
      {
         this.save({goToNext: true});
      }
   },
};
</script>

<style lang="scss" scoped>
.energy-base-line {
   font-family: $primary-font;
   color: $font-color;
   > .body {
      padding: 0.6em;
   }
   .step-title {
      span {
         font-family: $secondary-font;
         font-weight: 500;
         font-size: 1.05em;
      }
      font-family: inherit;
      display: flex;
      justify-content: space-between;
   }
   .baseline-radio {
      margin-top: -0.9em;
      padding-left: 1em;
   }
   .note {
      font-size: 0.8em;
   }

   .btn-group {
      display: flex;
      margin: 0 0.3em;
      > * {
         margin-right: 0.3em;
         a {
            color:inherit;
         }
         &:last-child {
            margin-right: 0;
         }
      }
   }
}
</style>
